import { type PropsWithChildren } from 'react';

import { useIsUserInitialized } from '@/providers/Auth';

const UserRehydratedGate: React.FC<PropsWithChildren> = ({ children }) => {
  const isUserInitialized = useIsUserInitialized();
  return isUserInitialized ? <>{children}</> : null;
};

export default UserRehydratedGate;
